import { MapTo } from '@adobe/aem-react-editable-components';
import ConfirmationPageDisclaimer, { ConfirmationPageDisclaimerEditConfig } from './ConfirmationPageDisclaimer';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/confirmation-page-disclaimer',
)(ConfirmationPageDisclaimer, ConfirmationPageDisclaimerEditConfig);